import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { selectDashboardInfo } from "../../../state/ducks/dashboard";
import { canInstallmentPaymentService } from "../../../services/member.service";
import { PAYMENT_STEP_COUNT, renderPaymentSteps } from "./paymentSteps";
import EminevimLoading from "../shared/EminevimLoading";

const PAYMENT_TYPE_OPTIONS = [
  {
    value: "1",
    label: "Tek Çekim",
    hint: "Tek seferde ödeme",
    iconClass: "t-icon-credit_card",
    cardClass: "t-smartCalculation-choiceCard--arac",
    inputId: "payment-type-single",
  },
  {
    value: "2",
    label: "Taksitli",
    hint: "Aylık talimat",
    iconClass: "t-icon-layers",
    cardClass: "t-smartCalculation-choiceCard--ev",
    inputId: "payment-type-installment",
  },
];

const getPaymentTypeLabel = (paymentType) =>
  PAYMENT_TYPE_OPTIONS.find((option) => option.value === paymentType)?.label || "";

const getPaymentThemeClass = (paymentType) =>
  paymentType === "2" ? "t-memberDetail-header--green" : "t-memberDetail-header--blue";

export class CreatePayment extends Component {
  state = {
    paymentType: "1",
    formError: "",
    shouldAnimateCard: false,
    canInstallmentPayment: null,
  };

  componentDidMount() {
    this.setState({ shouldAnimateCard: true });
    window.setTimeout(() => this.setState({ shouldAnimateCard: false }), 900);
    this.loadCanInstallmentPayment();
  }

  loadCanInstallmentPayment = () => {
    canInstallmentPaymentService()
      .then((response) => {
        const canInstallment = response?.data === true || response?.Data === true;

        this.setState((prev) => ({
          canInstallmentPayment: canInstallment,
          paymentType: !canInstallment && prev.paymentType === "2" ? "1" : prev.paymentType,
        }));
      })
      .catch(() => {
        this.setState({ canInstallmentPayment: false, paymentType: "1" });
      });
  };

  getPaymentTypeOptions = () => {
    const { canInstallmentPayment } = this.state;

    if (canInstallmentPayment !== true) {
      return PAYMENT_TYPE_OPTIONS.filter((option) => option.value === "1");
    }

    return PAYMENT_TYPE_OPTIONS;
  };

  handlePaymentTypeChange = (event) => {
    this.setState({
      paymentType: event.target.value,
      formError: "",
    });
  };

  onSubmit = (event) => {
    event.preventDefault();

    const { paymentType } = this.state;
    const { dashboard, history } = this.props;

    if (!paymentType || paymentType === "0") {
      this.setState({ formError: "Ödeme şekli boş bırakılamaz." });
      return;
    }

    if (paymentType === "2") {
      if (dashboard?.installmentPaymentBankType === "1") {
        history.push({ pathname: "/Home/CreatePaymentOrderPayTr", state: { paymentType: 2 } });
      } else if (dashboard?.installmentPaymentBankType === "2") {
        history.push({ pathname: "/Home/CreatePaymentOrderEminPay", state: { paymentType: 2 } });
      }
      return;
    }

    if (dashboard?.oneShotPaymentBankType === "0") {
      history.push("/Home/CreatePaymentOrder");
    } else if (dashboard?.oneShotPaymentBankType === "1") {
      history.push("/Home/CreatePaymentOrderPayFor");
    } else if (dashboard?.oneShotPaymentBankType === "2") {
      history.push({ pathname: "/Home/CreatePaymentOrderPayTr", state: { paymentType: 1 } });
    } else if (dashboard?.oneShotPaymentBankType === "3") {
      history.push({ pathname: "/Home/CreatePaymentOrderEminPay", state: { paymentType: 1 } });
    }
  };

  renderPaymentTypeChoices = () => {
    const { paymentType, formError, canInstallmentPayment } = this.state;
    const paymentTypeOptions = this.getPaymentTypeOptions();
    const isLoadingPaymentOptions = canInstallmentPayment === null;
    const isSingleChoice = canInstallmentPayment !== true;
    const showInstallmentPlaceholder = isLoadingPaymentOptions;

    return (
      <div className="t-createPayment-choiceSection">
        <div className="t-createPayment-choiceHead">
          <span className="t-createPayment-choiceEyebrow">Ödeme Şekli</span>
          <p className="t-createPayment-choiceDescription">
            Size uygun ödeme yöntemini seçerek talimat verme adımlarına devam edin.
          </p>
        </div>
        <div
          className={`t-smartCalculation-choiceGroup t-createPayment-choiceGroup${
            isSingleChoice && !showInstallmentPlaceholder ? " t-createPayment-choiceGroup--single" : ""
          }${formError ? " t-createPayment-choiceGroup--error" : ""}${
            isLoadingPaymentOptions ? " t-createPayment-choiceGroup--loading" : ""
          }`}
        >
          {paymentTypeOptions.map((option) => (
            <label
              key={option.value}
              className={`t-smartCalculation-choiceCard ${option.cardClass}`}
              htmlFor={option.inputId}
            >
              <input
                type="radio"
                id={option.inputId}
                name="paymentType"
                value={option.value}
                className="t-smartCalculation-choiceInput"
                checked={paymentType === option.value}
                onChange={this.handlePaymentTypeChange}
                disabled={isLoadingPaymentOptions}
              />
              <span className="t-smartCalculation-choiceIconWrap" aria-hidden="true">
                <i className={option.iconClass} />
              </span>
              <span className="t-smartCalculation-choiceLabel">{option.label}</span>
              <span className="t-smartCalculation-choiceHint">{option.hint}</span>
            </label>
          ))}
          {showInstallmentPlaceholder ? (
            <div
              className="t-smartCalculation-choiceCard t-smartCalculation-choiceCard--ev t-createPayment-choiceCard--disabled"
              aria-hidden="true"
            >
              <span className="t-smartCalculation-choiceIconWrap" aria-hidden="true">
                <i className="t-icon-layers" />
              </span>
              <span className="t-smartCalculation-choiceLabel">Taksitli</span>
              <span className="t-smartCalculation-choiceHint">Yükleniyor...</span>
            </div>
          ) : null}
        </div>
        {formError ? <p className="t-resetPassword-error t-createPayment-choiceError">{formError}</p> : null}
      </div>
    );
  };

  renderSteps = () => renderPaymentSteps(0);

  renderLoadingOverlay = () => {
    if (this.state.canInstallmentPayment !== null) {
      return null;
    }

    return (
      <div className="t-createPayment-processingOverlay">
        <EminevimLoading subtext="Ödeme seçenekleri yükleniyor, lütfen bekleyiniz." compact />
      </div>
    );
  };

  render() {
    const { paymentType, shouldAnimateCard, canInstallmentPayment } = this.state;
    const isLoadingPaymentOptions = canInstallmentPayment === null;

    return (
      <div className="t-createPayment-page" style={{ background: "#ffffff" }}>
        {this.renderLoadingOverlay()}
        <div className="row" style={{ padding: "3%" }}>
          <div className="col-12">
            <div className="t-memberInfo-pageHeader">
              <h1 className="t-memberInfo-pageTitle">Ödeme Talimatı</h1>
              <p className="t-memberInfo-pageSubtitle">
                Ödeme şeklinizi seçerek talimat verme adımlarına devam edin.
              </p>
            </div>

            <article
              className={`t-memberInfo-card ${getPaymentThemeClass(paymentType)}${
                shouldAnimateCard ? " t-memberInfo-card--enter" : ""
              }`}
            >
              <div className="t-memberInfo-cardHeader">
                <div className="t-memberDetail-headerIcon t-memberInfo-cardIcon">
                  <i className="t-icon-wallet" aria-hidden="true" />
                </div>

                <div className="t-memberInfo-cardHeaderContent">
                  <div className="t-memberInfo-cardTitleRow">
                    <h2 className="t-memberInfo-cardTitle">Ödeme Talimatı Verme</h2>
                    {paymentType ? (
                      <span className="t-memberInfo-typeChip">{getPaymentTypeLabel(paymentType)}</span>
                    ) : null}
                  </div>
                  <div className="t-memberInfo-cardBadges">
                    <span className="t-memberDetail-headerBadge">Adım 1 / {PAYMENT_STEP_COUNT}</span>
                  </div>
                </div>
              </div>

              <form className="t-resetPassword-form t-createPayment-form" onSubmit={this.onSubmit} noValidate>
                {this.renderPaymentTypeChoices()}

                <div className="t-createPayment-actions">
                  <button
                    type="submit"
                    className="t-memberInfo-btn t-memberInfo-btn--primary"
                    disabled={isLoadingPaymentOptions}
                  >
                    <span>Devam</span>
                    <i className="t-icon-arrow-right2" aria-hidden="true" />
                  </button>
                </div>
              </form>

              {this.renderSteps()}
            </article>
          </div>
        </div>
        <div className="row" style={{ height: 30 }} />
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  dashboard: selectDashboardInfo(state),
});

export default connect(mapStateToProps)(withRouter(CreatePayment));
